import { Link } from 'react-router-dom'
import { Result, Button } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'

export default function NotFound() {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--console-page-bg)]">
      <Result
        status="404"
        title="404"
        subTitle={t('common.notFound')}
        extra={
          <Link to="/">
            <Button type="primary">{t('common.backHome')}</Button>
          </Link>
        }
      />
    </div>
  )
}
